import { ActivityTableRow, ActivityTable, LinkStyled, ContentBoard } from '../styledComponents';
import { arrowDown, arrowUp, arrowDownGreen, arrowUpRed } from '../../../img';
import NoItemsInList from '../../../components/NoItemsInList';
import Scrollable from '../../../components/Scrollable';
import Loader from '../../../components/Loader';
import { useData, useFilter } from './context';
import React, { useMemo } from 'react';

export default function () {
  const { isLoading, dealers } = useData();
  const filter = useFilter();

  const linkQuery = useMemo(() => {
    let link = `?duration=${filter?.duration || 1}`;
    if (filter.source?.value) link += `&source=${filter.source?.value}`;
    if (filter.failReasons?.length)
      for (const reason of filter.failReasons) link += `&reasons=${reason.value}`;

    return link;
  }, [filter]);

  return (
    <ContentBoard heightCorrection={88}>
      {!!dealers?.length ? (
        <ActivityTable>
          <ActivityTableRow head columns={7}>
            <div>Dealership</div>
            <div>Units submitted</div>
            <div>Units verified</div>
            <div>Units failed</div>
            <div>Pass rate</div>
            <div>Fail rate</div>
            <div style={{ minWidth: 142, justifyContent: 'flex-start' }}>Fail reasons</div>
          </ActivityTableRow>
          <Scrollable>
            {dealers?.map((row, index) => (
              <ActivityTableRow key={'active-list--' + index} columns={7}>
                <div>{row.dealershipName}</div>
                <div>
                  <LinkStyled to={`/vehicles${linkQuery}&hmsId=${row.hmsId}`}>
                    {row.totalCount}
                  </LinkStyled>
                </div>
                <div>
                  {Boolean(row.successCount) ? (
                    <LinkStyled to={`/vehicles${linkQuery}&hmsId=${row.hmsId}&status=pass`}>
                      {row.successCount}
                    </LinkStyled>
                  ) : (
                    '-'
                  )}
                </div>
                <div>
                  {Boolean(row.failedCount) ? (
                    <LinkStyled to={`/vehicles${linkQuery}&hmsId=${row.hmsId}&status=fail`}>
                      {row.failedCount}
                    </LinkStyled>
                  ) : (
                    '-'
                  )}
                </div>
                <div className={row.passClassName}>
                  {row.passRate}%{' '}
                  {row.passRate > row.prevPassRate ? (
                    <img src={arrowUp} alt='' />
                  ) : row.passRate < row.prevPassRate ? (
                    <img src={arrowDown} alt='' />
                  ) : (
                    ''
                  )}
                </div>
                <div className={row.passClassName}>
                  {100 - row.passRate}%{' '}
                  {row.passRate > row.prevPassRate ? (
                    <img src={arrowDownGreen} alt='' />
                  ) : row.passRate < row.prevPassRate ? (
                    <img src={arrowUpRed} alt='' />
                  ) : (
                    ''
                  )}
                </div>
                <div className='fails'>
                  {row.failReasons.map((fail, index) => (
                    <div key={`dealer-fail--${row.hmsId}--${index}`}>
                      {fail.name}: {fail.value}%
                    </div>
                  ))}
                </div>
              </ActivityTableRow>
            ))}
          </Scrollable>
        </ActivityTable>
      ) : (
        <NoItemsInList>{!isLoading ? 'No reports to show' : ''}</NoItemsInList>
      )}
      <Loader isLoading={isLoading} firstLoad={true} />
    </ContentBoard>
  );
}
